import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import {
  backgroundConfigurationRequiredSelector,
  poseConfigurationRequiredSelector,
  selectInitialStepsComplete,
} from '../../../../../../selectors';
import BackgroundPosesContainer from './BackgroundPosesContainer';

const SelectedPosesAndBackgroundsContainer = styled.div`
  padding-bottom: 32px;
`;

const SelectedPosesAndBackgrounds = () => {
  const needsPoseSelection = useSelector(poseConfigurationRequiredSelector);
  const needsBackgroundSelection = useSelector(
    backgroundConfigurationRequiredSelector,
  );
  const initialStepsComplete = useSelector(selectInitialStepsComplete);

  // Both selectors fold runtime availability in: no pose step prepay, no
  // background step without a shoot catalogue or for background-skipped
  // digital downloads. Nothing configurable → no entry point.
  const showEntryPoint = needsPoseSelection || needsBackgroundSelection;

  if (!showEntryPoint) {
    return null;
  }

  // The instruction line self-hides on desktop via its own CSS
  // (.bnl-product-config__mobile-instruction is display:none at $screen-lg),
  // so a single container serves both breakpoints.
  //
  // Its wording tracks completion separately from the container's own guard,
  // which is structural ("does this product have slots"). Filling the last slot
  // closes the picker, which is exactly when ProductConfigurationSteps starts
  // showing "Configuration complete. Please click 'Add to Cart'" — so a fixed
  // "Tap to configure" put two contradictory directives on the mobile screen at
  // once, the stale one above the correct one.
  //
  // Keyed on selectInitialStepsComplete, not selectCanBeSubmitted: this line
  // labels the pose/background rows, and initial steps is exactly
  // "poses/backgrounds/crops done". A product still awaiting personalization has
  // canBeSubmitted false while its rows ARE done — pointing the customer back at
  // the rows there would send them to the wrong control.
  //
  // Replaced rather than hidden so the rows keep a visible affordance: they stay
  // tappable for reopening, and an unlabelled strip of thumbnails does not read
  // as interactive.
  return (
    <SelectedPosesAndBackgroundsContainer className="poses-backgrounds-container">
      <div className="bnl-product-config__mobile-instruction">
        {initialStepsComplete ? 'Tap to change' : 'Tap to configure'}
      </div>
      <BackgroundPosesContainer />
    </SelectedPosesAndBackgroundsContainer>
  );
};

export default SelectedPosesAndBackgrounds;
